import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

/** The newest post: everything the modal renders. */
export const whatsNewPostFragment = gql`
  fragment whatsNewPostFragment on Blog {
    _id
    title
    slug
    contentHtml
    createdAt
  }
`
export const whatsNewPostQueries = buildGraphqlQuery('Blog', whatsNewPostFragment)

/** The post the user last saw: only what the unseen check compares. */
export const whatsNewSeenFragment = gql`
  fragment whatsNewSeenFragment on Blog {
    _id
    createdAt
  }
`
export const whatsNewSeenQueries = buildGraphqlQuery('Blog', whatsNewSeenFragment)
